import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'Send order',
      title: 'Send order',
      executeAction: 'Submit',
      errorMessage: 'Error',
      successMessage: 'Order successfully sent',
    }
  }
}